import {
	endpointsMap,
	IShareWishlistOptions,
	IShareWishlistResponse
} from './ICustomShopperWishlist';

import AbstractCustomShopperAPI from '../AbstractCustomShopperAPI';
import {ICustomApiConfig} from '../ICustomApiConfig';

/**
 * Represents CustomShopperWishlist
 */
class CustomShopperWishlist extends AbstractCustomShopperAPI {
	/**
	 * @constructor
	 * @param {ICustomApiConfig} config - API Config
	 */
	constructor(config: ICustomApiConfig) {
		super(config);
	}

	/**
	 * Shares the wishlist
	 * @param {IShareWishlistOptions} fetchOptions - options to pass to API Call
	 * @param {boolean} throwOnError - throw error if api returns error
	 *
	 * @returns {IShareWishlistResponse} - Status of the request
	 */
	public async shareWishlist(fetchOptions: IShareWishlistOptions, throwOnError?: boolean): Promise<IShareWishlistResponse> {
		const response: IShareWishlistResponse = await this.callCustomEndpoint<IShareWishlistResponse>(
			fetchOptions,
			endpointsMap.SHARE
		);

		if (throwOnError && response.message !== 'WISHLIST_EMAIL_SENT') {
			throw new Error('Wishlist sharing failed');
		}

		return response;
	}
}

export default CustomShopperWishlist;
